import { useState, useEffect, useLayoutEffect, createContext, useContext } from 'react';
import { listRows } from '@/api/supabaseClient';
import { applyTheme, DEFAULT_LOGO } from '@/lib/themes';

const TemaContext = createContext(null);
const THEME_CACHE_KEY = 'cdi-theme-config';

function readCachedTheme() {
  try {
    const stored = window.localStorage.getItem(THEME_CACHE_KEY);
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
}

export function TemaProvider({ children }) {
  const [config, setConfig] = useState(readCachedTheme);

  useLayoutEffect(() => {
    if (config) applyTheme(config);
  }, [config]);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const configs = await listRows('tema_config', { orderBy: 'created_at', ascending: false, limit: 1 });
        if (active && configs.length > 0) {
          setConfig(configs[0]);
          try { window.localStorage.setItem(THEME_CACHE_KEY, JSON.stringify(configs[0])); } catch {}
        }
      } catch {}
    })();
    return () => {
      active = false;
    };
  }, []);

  return (
    <TemaContext.Provider value={{ config, setConfig }}>
      {children}
    </TemaContext.Provider>
  );
}

export const useTema = () => useContext(TemaContext);
export { DEFAULT_LOGO };
